import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-reorder-dialog',
  templateUrl: './reorder-dialog.component.html',
  styleUrls: ['./reorder-dialog.component.scss']
})
export class ReorderDialogComponent {

  displayMsg = false;
  resultMsg = "";
  dangerMsg = false;
  searchVal = "";
  constructor(
    public dialogRef: MatDialogRef<ReorderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private readonly appService: AppService
  ) {

  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.data, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.data.length; i++) {
      this.data[i].newSeq = i + 1;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  okForReorder() {
    debugger;
    if (this.data[0].pageName == "Content") {
      for (let i = 0; i < this.data.length; i++) {
        this.data[i].contentSeq = this.data[i].newSeq;
        this.appService.reorderTrainingContent(this.data[i]).subscribe((data: any) => {
          if (i == this.data.length - 1) {
            if (data.resultType == "S") {
              this.dialogRef.close(data);
            } else {
              this.displayMsg = false;
              this.dangerMsg = true;
              this.resultMsg = data.result;
            }

          }
        })
      }
    } else {
      for (let i = 0; i < this.data.length; i++) {
        this.data[i].seq = this.data[i].newSeq;
        this.appService.reorderContentQuestion(this.data[i]).subscribe((data: any) => {
          if (i == this.data.length - 1) {
            if (data.resultType == "S") {
              this.dialogRef.close(data);
            } else {
              this.displayMsg = false;
              this.dangerMsg = true;
              this.resultMsg = data.result;
            }

          }
        })
      }
    }
  }

}
